import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Category - Get All (Read)
export const GetAllHistory = createAsyncThunk(
    "admin/color-predicition/all-history",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/bet?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&play_time_id=${filter?.option_id || ""}&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetAllPeriodHistory = createAsyncThunk(
    "admin/color-predicition/all-period-history",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/history?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&play_time_id=${filter?.option_id || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetSummaryData = createAsyncThunk(
    "admin/color-predicition/summary-data",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/summary_data?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetGameStatistic = createAsyncThunk(
    "admin/color-predicition/GetGameStatistic",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/statistic?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""
                }`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const PlaceBet = createAsyncThunk(
    "auth/PlaceBet/post",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Games.Color_Prediction + "/bet", data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const GetPeriodResult = createAsyncThunk(
    "auth/GetPeriodResult/post",
    async (query, { rejectWithValue }) => {
        try {
            const res = await GET(APIS.Games.Color_Prediction + `/result?period=${query?.period || ""}&play_time_id=${query?.play_time_id || ""}`);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const GetHowToPlay = createAsyncThunk(
    "auth/GetHowToPlay/post",
    async (_, { rejectWithValue }) => {
        try {
            const res = await GET(APIS.Commons.WingoRule);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const Slice = createSlice({
    name: "color_redictions",
    initialState: {
        data: [],
        Game_data: [],
        summary_data: {},
        history_pagination: {
            current_page: IDS.PAGE,
            total_pages: IDS.TOTALPAGES,
            per_page: IDS.PERPAGE,
            total: IDS.TOTAL,
        },
        period_pagination: {
            current_page: IDS.PAGE,
            total_pages: IDS.TOTALPAGES,
            per_page: IDS.PERPAGE,
            total: IDS.TOTAL,
        },

        statistic_data: {},
        how_to_data: {},
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetCategory, AddCategory, UpdateCategory, DeleteCategory
            .addCase(GetAllHistory.pending, (state) => {
                state.history_status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllHistory.fulfilled, (state, action) => {
                state.history_status = IDS.SLICESTATUS.Succeeded;

                state.Game_data = action.payload?.data?.data || [];

                state.history_pagination = {
                    current_page: action.payload?.data?.current_page || IDS.PAGE,
                    total_pages: action.payload?.data?.total_pages || IDS.TOTALPAGES,
                    per_page: action.payload?.data?.per_page || IDS.PERPAGE,
                    total: action.payload?.data?.total || IDS.TOTAL,
                };
            })
            .addCase(GetAllHistory.rejected, (state, action) => {
                state.history_status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetAllPeriodHistory.pending, (state) => {
                state.period_status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllPeriodHistory.fulfilled, (state, action) => {
                state.period_status = IDS.SLICESTATUS.Succeeded;

                state.data = action.payload?.data?.data || [];

                state.period_pagination = {
                    current_page: action.payload?.data?.current_page || IDS.PAGE,
                    total_pages: action.payload?.data?.total_pages || IDS.TOTALPAGES,
                    per_page: action.payload?.data?.per_page || IDS.PERPAGE,
                    total: action.payload?.data?.total || IDS.TOTAL,
                };
            })
            .addCase(GetAllPeriodHistory.rejected, (state, action) => {
                state.period_status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(GetSummaryData.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSummaryData.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.summary_data = action.payload?.data || [];

            })
            .addCase(GetSummaryData.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetGameStatistic.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetGameStatistic.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.statistic_data = action.payload?.data || [];

            })
            .addCase(GetGameStatistic.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetHowToPlay.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetHowToPlay.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.how_to_data = action.payload?.data || [];

            })
            .addCase(GetHowToPlay.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

export const { } = Slice.actions;

export default Slice.reducer;
